import get from 'lodash/get';
import defaultConfig from '../config/default.json';

class Config {

    constructor() {
        this.init();
    }

    init() {
        this.cache = Object.assign({}, defaultConfig); 
    }

    get(path) {
        return get(this.cache, path);
    }
}

export default new Config();